// Sentry observability for the web app (B5 two-branch — D8/F06). Scrubbing is mandatory on BOTH
// branches: `sendDefaultPii: false` plus the shared `sentryBeforeSend` (deny-lists Class-B bodies +
// Class-C identifiers + credentials). The SDK loads via a runtime specifier so it isn't a hard build
// dependency, and init is a no-op without a DSN (VITE_SENTRY_DSN_WEB is injected at the Docker build).
import { sentryBeforeSend } from "@forcebase-ai/core";

export async function initObservability(): Promise<void> {
  const dsn = import.meta.env.VITE_SENTRY_DSN_WEB as string | undefined;
  if (!dsn) return;
  const pkg: string = "@sentry/react";
  try {
    const Sentry = (await import(pkg)) as { init: (o: Record<string, unknown>) => void };
    Sentry.init({
      dsn,
      sendDefaultPii: false, // mandatory — never attach PII (D8/B5)
      tracesSampleRate: 0.1,
      beforeSend: sentryBeforeSend,
    });
  } catch {
    // observability must never break the app
  }
}
